// extracted by mini-css-extract-plugin
export var image = "imageBlob-module--image--da351";